import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconCartographyModuleM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M 2.5 0 C 1.1193 0 0 1.1193 0 2.5 V 11.5 C 0 12.8807 1.1193 14 2.5 14 H 11.5 C 12.8807 14 14 12.8807 14 11.5 V 2.5 C 14 1.1193 12.8807 0 11.5 0 H 2.5 Z M 1 2.5 C 1 1.6716 1.6716 1 2.5 1 H 2.8364 L 1 3.1886 V 2.5 Z M 1 4.7443 L 4.1418 1 H 6.2476 L 1 7.2538 V 4.7443 Z M 7.553 1 H 9.6587 L 1 11.3191 V 8.8095 L 7.553 1 Z M 10.9642 1 H 11.5 C 11.9533 1 12.3596 1.2011 12.6347 1.5189 L 3.0008 13 H 2.5 C 2.0369 13 1.6229 12.7902 1.3477 12.4604 L 10.9642 1 Z M 13 2.6392 V 5.1488 L 6.412 13 H 4.3063 L 13 2.6392 Z M 13 6.7045 V 9.2141 L 9.8232 13 H 7.7174 L 13 6.7045 Z M 13 10.7698 V 11.5 C 13 12.3284 12.3284 13 11.5 13 H 11.1286 L 13 10.7698 Z" />
    </svg>
  )
}

export const IconCartographyModule = createIcon({
  l: IconCartographyModuleM,
  m: IconCartographyModuleM,
  s: IconCartographyModuleM,
  xs: IconCartographyModuleM,
  name: 'IconCartographyModule',
})
